import type { FlowNodeResultADT, WechatTemplateMessageActionConfigure } from '@lighthouse/shared'
import {
    type ActionFlowNode,
    generateVariableValue,
    resolvedUpstreamVariableValue,
    type WechatTemplateMsgActionConfig
} from '@lighthouse/shared'
import { safeToString } from '@lighthouse/tools'
import { t } from 'i18next'

import * as srv from '@/services'

import type { ExecuteActionParams } from '../type'

export const handleWechatTemplateMsgStream = async (
    node: ActionFlowNode<WechatTemplateMessageActionConfigure>,
    params: ExecuteActionParams
): Promise<undefined | FlowNodeResultADT> => {
    const {
        data: { config }
    } = node

    if (!config) {
        throw new Error(t('configurationNotPerfect'))
    }

    const success = await handleWechatTemplateMsg(config, params)
    if (!success) {
        throw new Error(t('sendWxTemplateMsgError'))
    }
    return { type: 'record', success }
}

export const handleWechatTemplateMsg = (config: WechatTemplateMsgActionConfig, params: ExecuteActionParams) => {
    const { templateId, personList: configAddresseeIds, values, url } = config

    const persons = resolvedUpstreamVariableValue({ data: configAddresseeIds, extraParams: params })

    const valuesValues = values.map(value => {
        const v = generateVariableValue({
            innerType: 'TEXT',
            jsonContent: value.value,
            extraParams: params,
            options: {
                useFileUrl: true,
                format: true
            }
        })
        return {
            variableName: value.variableName,
            value: safeToString(v)
        }
    })
    const urlValue = generateVariableValue({
        innerType: 'TEXT',
        jsonContent: url,
        extraParams: params,
        options: {
            useFileUrl: true,
            format: true
        }
    })
    return srv.wxTemplateMessageAction({
        addresseeIds: persons,
        templateId,
        url: safeToString(urlValue),
        values: valuesValues
    })
}
